var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/ArrowTabs.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowTabs = ({
  color = '#A2A3B7',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M6.21232 2.24248C6.57982 1.87498 7.17232 1.87498 7.53982 2.24248L13.7723 8.47498C14.0648 8.76748 14.0648 9.23998 13.7723 9.53248L7.53982 15.765C7.17232 16.1325 6.57982 16.1325 6.21232 15.765C5.84482 15.3975 5.84482 14.805 6.21232 14.4375L11.6423 8.99998L6.20483 3.56248C5.84482 3.20248 5.84482 2.60248 6.21232 2.24248Z",
    fill: color
  })
});